import type { HelpFile } from '../../types/help'
import { CertificationDashboardTestIds } from '../../../testids/CertificationDashboardTestIds'

export const certificationDashboardHelp: HelpFile = {
  docPage: '/docs/governance/certification',
  texts: {
    [CertificationDashboardTestIds.certificationDashboard]:
      'Übersicht über aktive Zertifizierungskampagnen, offene Prüfaufgaben und Zertifizierungsstatistiken.',
    [CertificationDashboardTestIds.certificationDashboardSummary]:
      'Kennzahl-Kacheln zur Kampagnen- und Prüfaktivität in der gesamten Organisation.',
    [CertificationDashboardTestIds.cardActiveCampaigns]: null,
    [CertificationDashboardTestIds.cardActiveCampaignsTable]:
      'Laufende Zertifizierungskampagnen — in eine Zeile einsteigen zeigt Reviews, Entscheidungen und Fortschritt.',
    [CertificationDashboardTestIds.cardCampaignManagement]:
      'Verwaltungsansicht aller Kampagnen — Abdeckung, Status und Verantwortlichkeiten im Blick behalten.',
    [CertificationDashboardTestIds.cardDecisionsOverview]:
      'Prüfentscheidungen über alle aktiven Kampagnen aufgeteilt in Behalten, Entzogen und Offen.',
    [CertificationDashboardTestIds.cardReviewProgress]:
      'Fortschritt der Prüfer bei ihren zugewiesenen Positionen in der aktuellen Periode.',
    [CertificationDashboardTestIds.cardTitleActiveCampaigns]: null,
    [CertificationDashboardTestIds.cardTitleCampaignManagement]: null,
    [CertificationDashboardTestIds.kpiActiveCampaignsValue]: null,
    [CertificationDashboardTestIds.kpiDecisionsOverviewValue]: null,
    [CertificationDashboardTestIds.kpiOverdueBadge]:
      'Aktive Kampagnen, deren Fälligkeitsdatum überschritten ist und die noch offene Positionen haben.',
    [CertificationDashboardTestIds.kpiReviewProgressValue]: null,
    [CertificationDashboardTestIds.colCampaign]: null,
    [CertificationDashboardTestIds.colDueDate]:
      'Datum, bis zu dem alle Reviews dieser Kampagne abgeschlossen sein müssen.',
    [CertificationDashboardTestIds.colKeep]:
      'Prüfpositionen mit Entscheidung Behalten — Zugriff bleibt bestehen.',
    [CertificationDashboardTestIds.colRevoked]:
      'Prüfpositionen mit Entscheidung Entzogen — Zugriff wird entfernt.',
    [CertificationDashboardTestIds.colUndecided]:
      'Prüfpositionen, die noch auf eine Entscheidung warten.',
    [CertificationDashboardTestIds.colProgress]: null,
    [CertificationDashboardTestIds.colManagementName]: null,
    [CertificationDashboardTestIds.colManagementOwner]:
      'Identität, die für die Durchführung der Kampagne verantwortlich ist und Prüfer nachverfolgt.',
    [CertificationDashboardTestIds.colManagementPolicy]:
      'Zertifizierungsrichtlinie, aus der die Kampagne entstanden ist — legt Umfang, Prüfer und Zyklus fest.',
    [CertificationDashboardTestIds.colManagementStatus]: null,
    [CertificationDashboardTestIds.colManagementDueDate]: null,
    [CertificationDashboardTestIds.btnCreateCampaign]:
      'Neue Zertifizierungskampagne manuell auf Basis einer bestehenden Zertifizierungsrichtlinie anlegen.',
    [CertificationDashboardTestIds.btnGenerateCampaigns]:
      'Scheduler veranlassen, alle gemäß ihren Richtlinien fälligen Kampagnen zu erzeugen.',
  },
}
